(() => {
  if (customElements.get('ss-real-life')) return;
  class SoulyshineRealLife extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.rail = this.querySelector('.ssrl__rail');
      this.cards = [...this.querySelectorAll('.ssrl__card')];
      this.filters = [...this.querySelectorAll('[data-topic]')];
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('[data-player]');
      this.media = new Map();
      this.cards.forEach(card => {
        const fallback = card.querySelector('.ssrl__fallback');
        if (fallback && typeof this.dialog.showModal === 'function') {
          this.media.set(card, fallback);
          fallback.remove();
          card.querySelector('[data-open]').hidden = false;
        }
      });
      this.querySelector('.ssrl__filters').hidden = false;
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-topic]');
        if (filter) this.filter(filter.dataset.topic);
        const open = event.target.closest('[data-open]');
        if (open) this.openVideo(open.closest('.ssrl__card'), open);
        if (event.target.closest('[data-close]')) this.dialog.close();
        const arrow = event.target.closest('[data-direction]');
        if (arrow) {
          const first = this.cards.find(card => !card.hidden);
          if (first) this.rail.scrollBy({left: Number(arrow.dataset.direction) * (first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
      }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => this.stopVideo(), {signal});
      this.rail.addEventListener('scroll', () => this.updateNavigation(), {signal, passive:true});
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
        if (card) {this.filter('all'); this.rail.scrollLeft = card.offsetLeft - this.cards[0].offsetLeft;}
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.player.querySelector('video')?.pause();
      }, {signal});
      this.observer = new ResizeObserver(() => this.updateNavigation());
      this.observer.observe(this.rail);
      this.filter('all', false);
    }
    filter(topic, announce = true) {
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = topic !== 'all' && !JSON.parse(card.dataset.topics).includes(topic);
        if (!card.hidden) count++;
        if (card.hidden) card.querySelector('video')?.pause();
      });
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topic === topic)));
      this.rail.scrollLeft = 0;
      if (announce) this.querySelector('[data-status]').textContent = `${count} ${count === 1 ? 'video' : 'videos'}${topic === 'all' ? '' : `: ${topic}`}`;
      this.updateNavigation();
    }
    updateNavigation() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      this.querySelector('[data-navigation]').hidden = max < 3;
      this.querySelector('[data-direction="-1"]').disabled = this.rail.scrollLeft < 3;
      this.querySelector('[data-direction="1"]').disabled = this.rail.scrollLeft >= max - 3;
    }
    openVideo(card, opener) {
      document.querySelectorAll('ss-real-life dialog[open]').forEach(dialog => dialog.close());
      this.opener = opener;
      this.querySelector('[data-dialog-title]').textContent = card.querySelector('.ssrl__title').textContent;
      const video = this.media.get(card).querySelector('video').cloneNode(true);
      video.controls = true;
      video.playsInline = true;
      video.preload = 'metadata';
      this.player.replaceChildren(video);
      this.dialog.showModal();
      video.play().catch(() => {});
    }
    stopVideo() {
      const video = this.player.querySelector('video');
      if (video) {video.pause(); video.removeAttribute('src'); video.querySelectorAll('source').forEach(source => source.remove()); video.load();}
      this.player.replaceChildren();
      if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.stopVideo();
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.media?.forEach((fallback, card) => {card.querySelector('.ssrl__media').append(fallback); card.querySelector('[data-open]').hidden = true;});
    }
  }
  customElements.define('ss-real-life', SoulyshineRealLife);
})();
